/**
 * Check if argument is an array.
 *
 * @param {any} data
 * @returns {boolean}
 */
const isArray = data => Array.isArray(data)

/**
 * Check if argument is a date.
 *
 * @param {any} data
 * @returns {boolean}
 */
const isDate = data => data instanceof Date

/**
 * Check if argument is null or undefined.
 *
 * @param {any} data
 * @returns {boolean}
 */
const isNullOrUndefined = data => data === null || data === undefined

/**
 * Check if argument is an object.
 *
 * @param {any} data
 * @returns {boolean}
 */
const isObject = data =>
  !isNullOrUndefined(data) && !isArray(data) && !isDate(data) && typeof data === 'object'

/**
 * Check if argument is a number or a numeric string.
 *
 * @param {any} data
 * @returns {boolean}
 */
const isNumber = data =>
  typeof data === 'number' ||
  (typeof data === 'string' && data.trim() !== '' && !isNaN(Number(data)))

/**
 * Check if argument is a boolean.
 *
 * @param {any} data
 * @returns {boolean}
 */
const isBoolean = data => {
  return (
    typeof data === 'boolean' ||
    (typeof data === 'string' && data.trim() !== '' && (data === 'true' || data === 'false'))
  )
}

/**
 * Check if argument is an string.
 *
 * @param {string} str
 * @returns {boolean}
 */
const isString = str => typeof str === 'string'
/**
 * Check if argument is an empty string.
 *
 * @param {string} str
 * @returns {boolean}
 */
const isEmptyString = str => typeof str === 'string' && str.trim() === ''

/**
 * Check if argument is a string that can be parsed into a valid date.
 *
 * @param {string} str
 * @returns {boolean}
 */
const isDateString = str => {
  if (typeof str !== 'string') return false
  const date = new Date(str)
  return !isNaN(date.getTime())
}
export {
  isArray,
  isBoolean,
  isDate,
  isDateString,
  isEmptyString,
  isNullOrUndefined,
  isNumber,
  isObject,
  isString
}
